import axios from '@plugins/axios'
import store from '@state/store'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_HABEAS_DATA(state, habeasData) {
    state.cached = habeasData
  },
}

export const actions = {
  init({ state, dispatch }) { },
  // post message habeas data, captación pos or both
  fetchMessageHabeas(context, data) {
    return axios
      .post(`${serverUrl}/euro_habeas_data/formulario/${data.idForm}`, data.body)
      .then((response) => {
        return response.data
      })
  },

  createBulkHabeasAction(context, data) {
    return axios
      .post(`${serverUrl}/euro_habeas_data/set_clients/`, data)
      .then((response) => {
        return response.data
      })
  },

  sendHabeasDataSurvey(context, data) {
    return store.dispatch('appAuth/appLogIn')
      .then(() => {
        return axios
          .post(`${serverUrl}/euro_habeas_data/set_client/`, data, { 'appRequest': true })
          .then((response) => {
            return response.data
          })
      })
  },
}
